/**
 * @generated SignedSource<<b8cffe056f5906b94a7b0cac06258074>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InsightsTabTimeSeries_brand$data = {
  readonly currencyCode: string;
  readonly " $fragmentType": "InsightsTabTimeSeries_brand";
};
export type InsightsTabTimeSeries_brand$key = {
  readonly " $data"?: InsightsTabTimeSeries_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InsightsTabTimeSeries_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InsightsTabTimeSeries_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencyCode",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "03ede29aa16f67af36d78da5df764e69";

export default node;
